"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyType = void 0;

var _types = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/types");

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var PROPERTY_KEY = 'type';
/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertyType = function getPropertyType(upgradeData, upgradeSource) {
  var propertyValue = _types.types[upgradeSource];
  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};

exports.getPropertyType = getPropertyType;